import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAIAssistant } from "../context/AIAssistantContext";
import { pageContextForPath, resolveAINavigation } from "../copilot/pageContext";

export default function AIPageContextBridge() {
  const location = useLocation();
  const navigate = useNavigate();
  const handledNavigation = useRef(null);
  const { setAIRouteContext, navigationAction, contextScopeKey } = useAIAssistant();
  const previous = useRef({ scope: contextScopeKey, pathname: location.pathname });
  useLayoutEffect(() => {
    const next = pageContextForPath(location.pathname);
    const oldEntityRoute = previous.current.scope !== contextScopeKey && previous.current.pathname === location.pathname && next?.entity_public_id;
    previous.current = { scope: contextScopeKey, pathname: location.pathname };
    setAIRouteContext(oldEntityRoute ? null : next);
  }, [location.pathname, location.key, setAIRouteContext, contextScopeKey]);
  useEffect(() => {
    if (!navigationAction || navigationAction.scopeKey !== contextScopeKey || handledNavigation.current === navigationAction) return;
    handledNavigation.current = navigationAction;
    const path = resolveAINavigation(navigationAction.action);
    if (path) navigate(path);
  }, [navigationAction, navigate, contextScopeKey]);
  return null;
}
